import i18next from 'i18next'
import memoize from 'lodash/memoize'

// Need to have a memoize function on generators to prevent rerenders in redux-form
export const requiredMinCharCheck = (min: number) => (value: string) => {
  if (value && value.length >= min) {
    return undefined // no error
  }

  return i18next.t('global.characters_out_of_bounds_min', { value: min })
}

export const requiredMinChar = memoize(requiredMinCharCheck)
